/* ------------------------------------------------------------------ */
/* Melee — no ammunition, no recoil pattern that matters. `tryFire()`   */
/* branches on `class === 'melee'` and does a short raycast instead of  */
/* spawning a projectile (see WeaponSystem._meleeAttack). Every field   */
/* below still has to exist because `viewmodel.js` reads them           */
/* unconditionally every frame regardless of weapon type.               */
/* ------------------------------------------------------------------ */
export const WEAPON = {
  id: 'knife',
  label: 'Combat Knife',
  class: 'melee',
  caliber: null,
  /** Purchasable melee upgrade; fists remain the free starter. */
  price: 850,
  slot: 'melee',
  rpm: 130,
  modes: ['semi'],
  burstCount: 1,
  burstRpm: 130,
  burstDelay: 0.1,
  magSize: 0,
  reserve: 0,
  muzzleVelocity: 0,
  damage: 110,
  /** Applied only when the strike enters from behind the victim. */
  backstabDamage: 1200,
  backstabDot: 0.55,
  meleeRange: 1.4,
  penetration: 0,
  dropoff: 0,
  maxRange: 0,
  dragK: 0,
  tracerEvery: 999,
  spreadHip: 0,
  spreadAds: 0,
  spreadPerShot: 0,
  spreadMax: 0,
  spreadDecay: 1,
  recoil: {
    pitch: 0.01,
    yaw: 0.004,
    kickBack: 0.02,
    kickUp: 0.012,
    roll: 0.05,
    punch: 0.4,
    freq: 9,
    damping: 0.4,
    patternLength: 1,
    patternSeed: 0x1,
    climbShape: [1.0],
    drift: 0,
  },
  adsTime: 0.12,
  adsFov: 1.0,
  viewFov: 1.0,
  reloadTac: 0.01,
  reloadEmpty: 0.01,
  inspectTime: 2.2,
  drawTime: 0.3,
  holsterTime: 0.24,
  hipPos: [0.09, -0.14, -0.22],
  hipRot: [-0.1, 0.15, -0.1],
  adsCant: [0, 0, 0],
  eyeRelief: 0.2,
  sprintPos: [0.08, -0.2, -0.2],
  sprintRot: [-0.35, 0.5, 0.15],
  lowReadyPos: [0.09, -0.22, -0.22],
  lowReadyRot: [-0.4, 0.15, -0.08],
  swayScale: 1.3,
  bobScale: 1.2,
  magLen: 0.1,
};

export const loadModel = () => import('../models/knife.js').then((m) => m.buildKnife);
